import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import Switch from 'react-switch';

import Alert from '../../../../../../../../../../../components/global/Alert';
import InfoCircleIcon from '../../../../../../../../../../../components/icons/InfoCircleIcon';
import { ALBUM_SLIDESHOW_MODE } from '../../../../../../../../../../../constants/albums';
import { isAutoLayoutsSlideshow } from '../../../../../../../../../../../util/album';

const propTypes = {
  albumSlideshowMode: PropTypes.oneOf(Object.values(ALBUM_SLIDESHOW_MODE))
    .isRequired,
  onToggleAutoLayoutsMode: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

const AutoLayoutsToggle = ({
  albumSlideshowMode,
  onToggleAutoLayoutsMode,
  disabled,
}) => {
  return (
    <Alert
      type="info"
      className="d-flex w-100 justify-content-between align-items-center mb-2"
    >
      <div className="d-flex align-items-center">
        Collage-style
        <span
          data-tip=""
          data-for="smart-layout-tip"
          data-event="click"
          data-effect="solid"
          data-place="bottom"
          className="d-flex align-items-center ml-1"
        >
          <InfoCircleIcon size={16} />

          <ReactTooltip
            id="smart-layout-tip"
            className="tooltip"
            globalEventOff="click"
          >
            Collage-style automatically
            <br />
            organizes your photos into
            <br />
            collage&ndash;style slides. For
            <br />
            best results, a minimum of
            <br />
            8 photos is recommended.
            <br />
            <br />
            Turning off will make each
            <br />
            slide single photo.
          </ReactTooltip>
        </span>
      </div>
      <Switch
        uncheckedIcon={false}
        checkedIcon={false}
        height={20}
        width={40}
        onColor="#7ace21"
        offColor="#cdd6e4"
        disabled={disabled}
        onChange={() => onToggleAutoLayoutsMode()}
        checked={isAutoLayoutsSlideshow({ mode: albumSlideshowMode })}
      />
    </Alert>
  );
};
AutoLayoutsToggle.propTypes = propTypes;

export default AutoLayoutsToggle;
